import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import get from 'transmute/get';
import getIn from 'transmute/getIn';
import isNumber from 'transmute/isNumber';
import ViewerTopLevelLogicGroupItem from './ViewerTopLevelLogicGroupItem';
import BannersContainer from 'customer-data-filters-ui/components/common/BannersContainer';
import ScrollToFilterButton from '../common/ScrollToFilterButton';
import ViewerAddGroup from './ViewerAddGroup';
import { AutoSizer, List as VirtualizedList, CellMeasurerCache, CellMeasurer } from 'react-virtualized';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FullHeightContiner = styled.div.withConfig({
  displayName: "ViewerContentVirtualized__FullHeightContiner",
  componentId: "hw9qu2-0"
})(["height:100%;"]);
const cellMeasurerCache = new CellMeasurerCache({
  defaultHeight: 200,
  fixedWidth: true
});
const StyledVirtualizedList = styled(VirtualizedList)(({
  theme
}) => ({
  paddingTop: 0,
  paddingLeft: theme.space[400],
  paddingRight: theme.space[400],
  paddingBottom: theme.space[400]
}));
const ViewerContentVirtualized = () => {
  var _internalDraftValue$c;
  const {
    internalDraftValue,
    viewerConditionIdToHighlight = '',
    isInEditMode,
    testFiltersStatus,
    props: {
      matchStatuses,
      bannerComponents
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const [showTopOverhang, setShowTopOverhang] = useState(false);
  const [showBottomOverhang, setShowBottomOverhang] = useState(false);
  const onScroll = ({
    clientHeight,
    scrollHeight,
    scrollTop
  }) => {
    const shouldShowTopOverhang = scrollTop > 0;
    const shouldShowBottomOverhang = clientHeight + scrollTop < scrollHeight;
    if (shouldShowTopOverhang !== showTopOverhang) {
      setShowTopOverhang(shouldShowTopOverhang);
    }
    if (shouldShowBottomOverhang !== showBottomOverhang) {
      setShowBottomOverhang(shouldShowBottomOverhang);
    }
  };

  // number of groups + banners container + add filter button
  // @ts-expect-error size is possibly 'undefined'.
  const rowCount = (internalDraftValue === null || internalDraftValue === void 0 || (_internalDraftValue$c = internalDraftValue.conditions) === null || _internalDraftValue$c === void 0 ? void 0 : _internalDraftValue$c.size) + 2;
  const logicOperator = internalDraftValue === null || internalDraftValue === void 0 ? void 0 : internalDraftValue.logicGroupName;
  const rowRenderer = useCallback(({
    index,
    key,
    style,
    parent
  }) => {
    let content;
    if (index === 0) {
      content = /*#__PURE__*/_jsx(BannersContainer, {
        children: bannerComponents
      });
    } else if (index === rowCount - 1) {
      content = /*#__PURE__*/_jsx(ViewerAddGroup, {});
    } else {
      const logicGroupIndex = index - 1;
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      const group = internalDraftValue.conditions.get(String(logicGroupIndex));
      content = /*#__PURE__*/_jsx(ViewerTopLevelLogicGroupItem
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'unknown' is not assignable to type 'Map<stri... Remove this comment to see the full error message
      , {
        logicGroup: group,
        logicGroupIndex: logicGroupIndex
        // @ts-expect-error logicOperator might be undefined
        ,
        logicOperator: logicOperator
        // @ts-expect-error ts-migrate(2322) FIXME
        ,
        matchStatus: get(logicGroupIndex, matchStatuses)
      });
    }
    return /*#__PURE__*/_jsx(CellMeasurer, {
      cache: cellMeasurerCache,
      columnIndex: 0,
      parent: parent,
      rowIndex: index,
      children: ({
        registerChild
      }) =>
      /*#__PURE__*/
      // @bend-expect trellis-tokenized: style is coming from react-virtualized
      _jsx("div", {
        ref: registerChild,
        style: style,
        children: content
      })
    }, key);
  }, [bannerComponents, internalDraftValue, logicOperator, matchStatuses, rowCount]);
  const virtualizedListRef = useRef(null);
  const internalDraftValueRef = useRef(internalDraftValue);
  const isInEditModeRef = useRef(isInEditMode);
  const matchStatusesRef = useRef(matchStatuses);
  const testFiltersStatusRef = useRef(testFiltersStatus);
  useEffect(() => {
    if (internalDraftValue !== internalDraftValueRef.current || isInEditModeRef.current !== isInEditMode || matchStatusesRef.current !== matchStatuses || testFiltersStatusRef.current !== testFiltersStatus) {
      cellMeasurerCache.clearAll();
      internalDraftValueRef.current = internalDraftValue;
      isInEditModeRef.current = isInEditMode;
      matchStatusesRef.current = matchStatuses;
      testFiltersStatusRef.current = testFiltersStatus;

      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      virtualizedListRef.current.recomputeRowHeights();
    }
  }, [internalDraftValue, isInEditMode, matchStatuses, testFiltersStatus]);
  useEffect(() => {
    const decoupledConditionId = viewerConditionIdToHighlight.split('__');
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
    const logicGroupIndex = parseInt(getIn([0], decoupledConditionId), 10);
    if (isNumber(logicGroupIndex)) {
      // +1 for banners container
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      virtualizedListRef.current.scrollToRow(logicGroupIndex + 1);
    }
  }, [viewerConditionIdToHighlight]);
  return /*#__PURE__*/_jsxs(FullHeightContiner, {
    "data-selenium-test": "fr-viewer-panel",
    children: [/*#__PURE__*/_jsx(ScrollToFilterButton, {}), /*#__PURE__*/_jsx(AutoSizer, {
      children: ({
        height,
        width
      }) => /*#__PURE__*/_jsx(StyledVirtualizedList, {
        id: "cdf-viewer-scrolling-container",
        deferredMeasurementCache: cellMeasurerCache,
        height: height,
        onScroll: onScroll,
        overscanRowCount: 1,
        ref: virtualizedListRef,
        rowCount: rowCount,
        rowHeight: cellMeasurerCache.rowHeight,
        rowRenderer: rowRenderer,
        width: width
      })
    })]
  });
};
export default ViewerContentVirtualized;